module.exports = __webpack_public_path__ + "img/8.c5dc62b8.png";